import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import { useAuth } from '../context/AuthContext';
import '../styles/LandingPage.css';

/**
 * What the app is, for someone who has not signed in.
 *
 * The only screen that was not wrapped in BaseLayout, so it rendered without
 * the application shell every other route has.
 */
const LandingPage = () => {
  const { isAuthenticated } = useAuth();

  // A signed-in user hitting `/` was shown a marketing page inviting them to
  // sign up for an account they already have. Send them to their dashboard,
  // matching the guard on Login and Register.
  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return (
    <BaseLayout>
      <div className="landing">
        <header className="landing-header">
          <span className="pill">Loenhart Health</span>
          <h1 className="page-title landing-title">
            The Loenhart Training System
          </h1>
          <p className="body-copy landing-lede">
            Write a training block, prescribe it properly — sets, reps, tempo,
            rest and intensity — then log what actually happened against it.
          </p>

          <div className="landing-actions">
            <Link to="/register" className="btn-primary">
              Create account
            </Link>
            <Link to="/login" className="btn-ghost">
              Sign in
            </Link>
          </div>
        </header>

        {/*
          Three claims, each one the app actually does. The previous copy
          promised to "empower your Health and Fitness" and offered a "Beta
          Program", which described nothing a visitor could check.
        */}
        <div className="landing-grid">
          <article className="card landing-card">
            <h2 className="section-title landing-card-title">Prescribe precisely</h2>
            <p className="body-copy landing-card-text">
              Sets and reps are the easy part. Tempo, rest and intensity —
              absolute load, %1RM, RPE or RIR — are what make a block
              repeatable.
            </p>
          </article>

          <article className="card landing-card">
            <h2 className="section-title landing-card-title">Log what happened</h2>
            <p className="body-copy landing-card-text">
              Record every set against the prescription, including the ones that
              failed and the ones done at bodyweight. A training log that only
              holds the good sets is not a training log.
            </p>
          </article>

          <article className="card landing-card">
            <h2 className="section-title landing-card-title">Work in your own units</h2>
            <p className="body-copy landing-card-text">
              Kilograms or pounds, your choice. Loads are stored one way
              underneath, so your history stays comparable however you read it.
            </p>
          </article>
        </div>
      </div>
    </BaseLayout>
  );
};

export default LandingPage;
